import { Components, Theme } from '@mui/material/styles';

export default function MuiTypography(theme: Theme): Components['MuiTypography'] {
  return {
    defaultProps: {
      variant: 'body2',
      variantMapping: {
        display: 'h1',
        t1: 'h1',
        t1Underline: 'h1',
        t2: 'h2',
        t2Underline: 'h2',
        t3: 'h3',
        t3Underline: 'h3',
        t4: 'h4',
        t5: 'h5',
        t6: 'h6',
        lead: 'p',
        leadUnderline: 'p',
        leadItalic: 'p',
        body1: 'p',
        body1Underline: 'p',
        body1Italic: 'p',
        body1Bold: 'p',
        body2: 'p',
        body2Underline: 'p',
        body2Italic: 'p',
        quote1: 'blockquote',
        quote2: 'blockquote',
        stat: 'p',
        nav1: 'span',
        nav2: 'span',
        nav3: 'span',
        tab: 'span',
        post: 'h2',
        title1: 'h3',
        title1Underline: 'h3',
        title2: 'h4',
        title2Underline: 'h4',
        title3: 'h5',
        title3Underline: 'h5',
        subtitle1: 'p',
        subtitle1Italic: 'p',
        subtitle2: 'p',
        subtitle3: 'p',
        link1: 'span',
        link1Underline: 'span',
        link2: 'span',
        link2Underline: 'span',
        link3: 'span',
        link3Underline: 'span',
        overline1: 'span',
        overline2: 'span',
      },
    },
  };
}
